import list from './list'
import viewList from './view-list'

let sharedMutations = []
sharedMutations = sharedMutations.concat(list.sharedMutations)

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    list.state,
    viewList.state
  ),
  mutations: Object.assign(
    list.mutations,
    viewList.mutations
  ),
  sharedMutations: sharedMutations
}



// WEBPACK FOOTER //
// ./src/store/promo/index.js